import { render, staticRenderFns } from "./TableBodyPrototype.vue?vue&type=template&id=b6565d86&scoped=true"
import script from "./TableBodyPrototype.vue?vue&type=script&lang=js"
export * from "./TableBodyPrototype.vue?vue&type=script&lang=js"
import style0 from "./TableBodyPrototype.vue?vue&type=style&index=0&id=b6565d86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6565d86",
  null
  
)

export default component.exports